__turbopack_context__.v({
  "newsContainer": "News-module-scss-module__Ucr3wq__newsContainer",
});
